export const V2_PATH = '/v2';

export const AUTHENTICATION_PATH = '/authentication';
export const BASE_PATH = '/organizations';
export const PROJECT_PATH = '/projects';
export const APPLICATION_PATH = '/applications';
export const WEBHOOKS_PATH = '/webhooks';
export const INVITATIONS_PATH = '/invitations';
export const MEMBERS_PATH = '/members';
export const MEMBERSHIPS_PATH = '/memberships';
export const POLICIES_PATH = '/policies';
export const SECURITY_GROUPS_PATH = '/security_groups';
export const FLOWS_PATH = '/watches';
export const FLOW_REVISIONS_PATH = '/revisions';
export const REPLICATIONS_PATH = '/replications';
export const CREDENTIALS_PATH = '/credentials';
export const WATCH_COPY_PATH = '/copy';
export const WATCH_DELETE_PATH = '/delete';
export const WATCH_UPDATE_PATH = '/update';
export const ASSETS_MANAGER_PATH = '/assets_manager';
export const FILES = '/files';
export const JOBS = '/jobs';
